module.exports = __webpack_public_path__ + "img/UTQUAI-8.88c792f6.jpg";